import React from 'react';
import { Shield, Lock, AlertTriangle, FileCheck, Network, Cloud } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const iconMap = { Shield, Lock, AlertTriangle, FileCheck, Network, Cloud };

export const ServicesSection = ({ services }) => (
  <section id="services" className="py-12 md:py-16 lg:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Our Services</h2>
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto">
          Comprehensive cybersecurity solutions tailored to protect your business
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {services.map((service) => {
          const Icon = iconMap[service.icon];
          return (
            <Card key={service.id} className="border-slate-200 hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="h-12 w-12 bg-[#105EFF]/10 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="h-6 w-6 text-[#105EFF]" />
                </div>
                <CardTitle className="text-slate-900">{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-slate-600">{service.description}</CardDescription>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
